import React, { useEffect, useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import AuthContext from '../AuthContext';
import axiosInstance from '../axiosInstance';
import { Link } from 'react-router-dom';

const Header = () => {
    const permissions = JSON.parse(localStorage.getItem('permissions') || '[]');
    const homePath = permissions.includes('/dashboard') ? '/dashboard' : '/emicalculator';

    const navigate = useNavigate();
    const { logout } = useContext(AuthContext);
    const [subscription, setSubscription] = useState(null);
    const companyId = localStorage.getItem('company_id');

    useEffect(() => {
        if (companyId) {
            axiosInstance.get(`/payment/subscription/${companyId}`)
                .then(res => {
                    if (res.data.success) setSubscription(res.data.data);
                })
                .catch(err => console.error("Failed to fetch subscription:", err));
        }
    }, [companyId]);

    const handleLogout = () => {
        logout();
        navigate('/login');
    };

    return (
        <nav className="main-header navbar navbar-expand navbar-indigo navbar-dark">
            {/* Left navbar links */}
            <ul className="navbar-nav">
                <li className="nav-item">
                    <a className="nav-link" data-widget="pushmenu" href="#" role="button">
                        <i className="fas fa-bars"></i>
                    </a>
                </li>
                <li className="nav-item d-none d-sm-inline-block">
                    <Link to={homePath} className="nav-link">Home</Link>
                </li>
                {subscription?.active && (
                    <li className="nav-item d-none d-sm-inline-block">
                        <span className="nav-link text-white">
                            {subscription.plan_name} ends in <strong>{subscription.days_remaining}</strong> days
                        </span>
                    </li>
                )}
            </ul>

            {/* Right navbar links */}
            <ul className="navbar-nav ml-auto">
                <li className="nav-item">
                    <a className="nav-link" data-widget="fullscreen" href="#" role="button">
                        <i className="fas fa-expand-arrows-alt"></i>
                    </a>
                </li>

                {/* User Dropdown */}
                <li className="nav-item dropdown">
                    <a className="nav-link" data-toggle="dropdown" href="#">
                        <div className="user-panel d-flex align-items-center">
                            <img
                                src={`https://apiemiride.socialpartners.in/api/user/profilepicture/${localStorage.getItem('profile_picture')}`}
                                alt="User"
                                className="img-circle elevation-2"
                                style={{ width: '30px', height: '30px', objectFit: 'cover' }}
                                onError={(e) => { e.target.onerror = null; e.target.src = '/dist/img/profilepic.jpeg'; }}
                            />

                            <span className="ml-2 d-none d-md-inline text-white font-weight-bold">
                                {localStorage.getItem('name')}
                            </span>
                            <i className="fas fa-angle-down ml-2"></i>
                        </div>
                    </a>
                    <div className="dropdown-menu dropdown-menu-lg dropdown-menu-right animated fadeInDown">
                        <div className="dropdown-item user-header bg-primary text-center">
                            <img
                                src={`https://apiemiride.socialpartners.in/api/user/profilepicture/${localStorage.getItem('profile_picture')}`}
                                alt="User"
                                className="img-circle elevation-2"
                                style={{ width: '30px', height: '30px', objectFit: 'cover' }}
                                onError={(e) => { e.target.onerror = null; e.target.src = '/dist/img/profilepic.jpeg'; }}
                            />

                            <p className="text-white">
                                {localStorage.getItem('name')}<br />
                            </p>
                        </div>
                        <div className="dropdown-divider"></div>
                        <a href="/profile" className="dropdown-item">
                            <i className="fas fa-user mr-2"></i> Profile
                        </a>
                        <a href="/company" className="dropdown-item">
                            <i className="fas fa-building mr-2"></i> Company
                        </a>
                        <a href="/changepassword" className="dropdown-item">
                            <i className="fas fa-key mr-2"></i> Change Password
                        </a>
                        <div className="dropdown-divider"></div>
                        <button className="dropdown-item text-danger" onClick={handleLogout}>
                            <i className="fas fa-sign-out-alt mr-2"></i> Logout
                        </button>
                    </div>
                </li>
            </ul>
        </nav>
    );
};

export default Header;
